export const BROWSER_PROPERTY_UPDATE = 'BROWSER_PROPERTY_UPDATE';
